import { constructMediaQueries } from './mq';

const color = {
	backgroundApp: '#fff',
	background: '#f5f6f6',
	background2: '#fafafb',
	black: '#000',
	info: '#70c8ff',
	danger: '#c33232',
	dangerFaint: '#f9eaea',
	draft: '#b4b7bd',
	faint: '#e6e7e9',
	focusRing: '#0099f7',
	muted: '#606774',
	neutral: '#454D5C',
	primary: '#6f58c4',
	primaryDark: '#4b3895',
	primaryFaint: '#f0eef9',
	primaryMid: '#cfcbe9',
	primaryLight: '#9653d4',
	primaryMuted: '#eae6f6',
	secondary: '#2363ae',
	success: '#06a077',
	text: '#061125',
	tooltip: '#4e5360',
	warning: '#ec6709',
	white: '#fff'
};

/**
 * Our breakpoints should be defined from smallest to largest!
 */
// prettier-ignore
const breakpoints = {
	mobile: 320,
	large: 720,
	tablet: 960,
	desktop: 1024,
	largeDesktop: 1280,
	xLargeDesktop: 1440,
};

const fontWeight = {
	bold: 600,
	regular: 400,
	light: 300
};

const theme = {
	mq: constructMediaQueries(breakpoints),
	breakpoints,
	color,
	font: {
		// web-font loaded via shell html
		family: `'Open Sans', sans-serif`,
		weight: fontWeight,
		h1: `
			font-weight: ${fontWeight.light};
			font-size: 3.6rem;
			line-height: 4.9rem;
		`,
		h2: `
			font-weight: ${fontWeight.regular};
			font-size: 2.4rem;
			line-height: 3.3rem;
		`,
		h3: `
			font-weight: ${fontWeight.regular};
			font-size: 2rem;
			line-height: 2.7rem;
		`,
		h4: `
			font-weight: ${fontWeight.regular};
			font-size: 1.6rem;
			line-height: 2.2rem;		
		`
	},
	size: {
		headerHeight: 56,
		navCollapsed: 72,
		navExpanded: 264
	},
	timing: {
		navWidth: '0.25s',
		default: '0.2s'
	},
	pagePadding: {
		vertical: '24px',
		horizontal: '24px'
	},
	depth: {
		// z-index values.
		navigation: 10,
		modals: 20,
		popover: 30,
		notifications: 40
	},
	// Most interactive elements will receive automatic focus styling, however
	// if you need to replicate it for a custom element you can assign these
	// styles to remain consistent and finish it off with a colour of your choice.
	getFocusStyles: (focusColor = color.focusRing) => `
		outline: 0;
		box-shadow: 0 0 3px 0 ${focusColor};
	`,
	// Base box shadow values for the varying depths as defined by the designers
	shadow: {
		light: `
			box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.2);
		`,
		medium: `
			box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15), 0 3px 6px 0 rgba(0, 0, 0, 0.25);
		`,
		strong: `
			box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2), 0 6px 6px 0 rgba(0, 0, 0, 0.25);
		`
	}
};

export default theme;
